const MODULE_TYPES: Readonly<Record<string, string>> = {
  assortment: "assortment",
  "space-assortment": "space_assortment",
  "bulk-planogram": "bulk_plano",
  planogram: "planogram",
  "data-exploration": "data exploration",
  clustering: "clustering",
};

/** Route context takes precedence over a previous experiment's session value. */
export function sidebarExperimentType(url: string, fallback: string): string {
  const module = url.split(/[?#]/)[0].split("/")[2];
  return MODULE_TYPES[module] ?? fallback;
}

export function sidebarRouteSegment(type: string): string {
  return (
    Object.keys(MODULE_TYPES).find((module) => MODULE_TYPES[module] === type) ??
    type.replace(/\s+/g, "-")
  );
}
